module.exports = {
  __depends__: [ require(46) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(38) ],
  elementRegistry: [ 'type', require(40) ],
  elementFactory: [ 'type', require(39) ],
  eventBus: [ 'type', require(41) ],
  graphicsFactory: [ 'type', require(42) ]
};